export enum MobileHeaderVariant {
  White = "white",
  Gray = "gray",
  Transparent = "transparent",
}
